<div class="select-partner">
  <app-custom-dropdown-merchants
    *ngIf="model.merchants"
    [display]="model.merchantSelected?.fantasy_name ? 'fantasy_name' : 'name'"
    [items]="model.merchants"
    [user]="user"
    [selectedItem]="model.merchantSelected"
    (settings)="settings($event)"
    (change)="changeMerchant($event)"
  >
  </app-custom-dropdown-merchants>
</div>
